import { AthenaQuery } from './athena-query'

export const entities = []
export const resolvers = [AthenaQuery]
